export default __webpack_public_path__ + "static/media/DM.60f033ef.svg";